import React, { useState, useEffect } from 'react';
import style from "./BackButton.module.css"

import { useTouchClick } from "shared/hooks/useTouchClick";
import Center from 'layouts/wrapper/Center';
import Inline from 'layouts/container/Inline';
import Dummy from 'components/Dummy';
import P from 'components/P';
import homeBtnIcon from "resources/img/puffu/homebtn.svg";


function HorizontalBackButton({
    onGoBackBtnClick,
    brand
}) {

    const { handleTouchStart: goBackTouchStart, handleTouchEnd: goBackTouchEnd } = useTouchClick(onGoBackBtnClick, 10);

    // 터치 이벤트 핸들러 수정
    const handleTouchStartWithStop = (e) => {
        e.stopPropagation();  // 이벤트 전파 중지
        goBackTouchStart(e);
        console.log("click!!")
    };

    const handleTouchEndWithStop = (e) => {
        e.stopPropagation();  // 이벤트 전파 중지
        goBackTouchEnd(e);
    };

    return (
        <div style={{ position: 'absolute', top: brand ? '-60px': '30px', right: "48px", width: '17.4%' , zIndex: 99 }}>
            <div
                onPointerDown={handleTouchStartWithStop}
                onPointerUp={handleTouchEndWithStop}
                className={style.backBtn}
                style={{ height: "53px", backgroundColor: "white", border: "1.5px solid var(--main-color)", borderRadius: "3px", transform: "translateY(5px)" }}
            >
                <Center>
                    <Inline>
                        <img src={homeBtnIcon} width={"30px"} />
                        <Dummy width={"15px"} />
                        <P color={"var(--main-color)"} weight={900} font={"Pretendard"} size={"1.5vw"}>뒤로가기</P>
                    </Inline>
                </Center>
            </div>
        </div>
    )

};
export default HorizontalBackButton